import { SnapLayerAPIService } from './../../../model/api-services/snap-layer-api.service';
import { FiniteStateMachine } from 'src/app/model/FiniteStateMachine';
import { SpreadActions } from '../../../model/map-actions/spread-actions';
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, HostBinding, Input, OnInit, ViewChild } from '@angular/core';
import { ViewStackComponent } from '../../view-stack/view-stack.component';
import { DrawPaneComponent } from '../../draw-pane/draw-pane.component';
import { SLMap } from 'src/app/model/sl-map';
import { SelectionProxy } from 'src/app/model/selection-proxy';
import * as turf from '@turf/turf'
import { PixoSpatialCoord } from 'src/app/model/Pixospatial';


export type SpreadMethod = 'distribute' | 'split-distance' | 'split-number' | 'split-at';
@Component({
  selector: 'app-spread-tools',
  templateUrl: './spread-tools.component.html',
  styleUrls: ['./spread-tools.component.scss']
})
export class SpreadToolsComponent implements AfterViewInit {
  @HostBinding('class.hidden') hidden = false;
  private _spreadMethod: SpreadMethod = 'distribute';
  set spreadMethod(method: SpreadMethod) {
    if (this._spreadMethod === method) return;
    this._spreadMethod = method;
  }
  get spreadMethod(): SpreadMethod {
    return this._spreadMethod;
  }


  public get useVertexDirection(): boolean {
    return this.spreadMethod === 'distribute';
  }

  public states: FiniteStateMachine;
  public vertexDirection: 'to' | 'from' = 'to';
  public directional: boolean = false;

  public distributing: boolean = false;
  public splittingDistance: boolean = false;
  public splittingNumber: boolean = false;
  public splittingAt: boolean = false;
  public currentState: string = 'noState';
  public currentSegment?;
  public currentVertex?;
  public currentSnapPt?;
  public currentSnapSeg?;
  public toolChange = new EventEmitter<string>();
  public splitDistance = 0;
  public drawPane: DrawPaneComponent;
  public numSplits = 0;
  public selectedLength = undefined;
  private _drawPaneChanges?: SelectionProxy;
  private _geomType: string = '';
  @Input()
  set drawPaneChanges(changes: SelectionProxy) {
    if (!!this._drawPaneChanges) return;
    if (!changes) return;
    this._drawPaneChanges = changes;
    this._drawPaneChanges.RegisterListener('spread-tools', (params) => {
      if (params.properties.indexOf('snapGeomChange')) {
        const geometryLoad = this._drawPaneChanges.GetProperty('snapGeomChange')
        if (geometryLoad && !this.drawPane?.GetSnaps()?.points?.points?.length) {
          this.views.SetView('no-snap-layer');
        } else if (this.views.currentView.viewName === 'no-snap-layer') {
          this.Reset();
        }
        if (!this._geomType || this.drawPane?.GetSelectedFeature()?.type !== this._geomType) {
          switch (this.drawPane?.GetSelectedFeature()?.type) {
            case 'point':
              this.hidden = true;
              this._geomType = 'point';
              break;
            case 'line':
            case 'polygon':
              this.hidden = false;
              this._geomType = this.drawPane?.GetSelectedFeature().type;
              break;
            default:
              this.hidden = true;
              this._geomType = '';
          }
        }

      }
      this.UpdateSelections();
    })
    this.UpdateSelections();
  }

  private _map: SLMap;
  public set map(map: SLMap) {
    if (!!this._map) return;
    this._map = map;
    this.drawPane = map.component.drawPane;
    this.drawPaneChanges = this.drawPane.selectionProxy;

  }
  get spreadable(): boolean {
    if (!this.distributing) return false;
    if (!this.currentVertex || !this.distributeStart) return false;
    if (this.currentVertex.id === this.distributeStart.id) return;
    return true;
  }

  @ViewChild('views') views: ViewStackComponent;
  @ViewChild('distributeViews') distributeViews: ViewStackComponent;
  @ViewChild('distSplitViews') distSplitViews: ViewStackComponent;
  @ViewChild('numberSplitViews') numberSplitViews: ViewStackComponent;
  @ViewChild('midPointViews') midPointViews: ViewStackComponent;

  private _ready: boolean = false;
  constructor(private snapLayerAPI: SnapLayerAPIService, private cdr: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    this._ready = true;
    SpreadActions.RegisterComponent('spread-tools', this)
    this.states = new FiniteStateMachine(this, [
      'noState',
      'distributing:spread-distribute',
      'splittingDistance:split-distance',
      'splittingNumber:split-number',
      'splittingAt:split-at'
    ]);
    this.states.RegisterHandlers(
      (params: any) => {
        this.currentState = params.value;
        this.toolChange.emit(this.currentState);
        if (params.isOn) {
          this.SetView(params.value);
        } else {
          this.SetView('noState');
        }
        this.ModeUpdate();
      },
      () => {
        this.SetView('');
        this.toolChange.emit('');
      },
      () => {
        // this.RefreshActions();
      }
    );
    this.distributeViews.SetView('step1');
    this.distributeStart = undefined;
    this.distSplitViews.SetView('step1');
    this.numberSplitViews.SetView('step1');
    this.midPointViews.SetView('step1');
  }
  UpdateSelections() {

    if (!!this._drawPaneChanges) {
      this.currentSegment = this._drawPaneChanges.GetProperty('segment');
      this.currentVertex = this._drawPaneChanges.GetProperty('vertex');
      this.currentSnapPt = this._drawPaneChanges.GetProperty('snapVertex');
      this.currentSnapSeg = this._drawPaneChanges.GetProperty('snapSegment');
    }
    this.selectedLength = !this.currentSegment ? 0 : this.drawPane.spatialContext.CoordDistance(this.currentSegment.from.coord, this.currentSegment.to.coord);
    this.ModeUpdate();

  }

  ModeUpdate() {

    if (this.distributing) {
      if (!this.currentVertex) {
        this.distributeViews.SetView('step1')
      }
    }
    if (this.splittingNumber) {
      if (!this.currentSegment) {
        this.numberSplitViews.SetView('step1');
      } else if (this.numberSplitViews.selectedView === 'step1') {
        this.numberSplitViews.SetView('step2');
      }

    }
    if (this.splittingDistance) {
      if (!this.currentSegment) {
        this.distSplitViews.SetView('step1');
      } else if (this.distSplitViews.selectedView === 'step1') {
        this.distSplitViews.SetView('step2');
      }

    }
    if (this.splittingAt) {
      if (!this.currentSegment) {
        this.midPointViews.SetView('step1');
      } else if (this.midPointViews.selectedView === 'step1') {
        this.midPointViews.SetView('step2');
      }
    }
    this.Refresh();
  }
  SetTool(toolId: string, params: { enabled: boolean, map: SLMap }) {
    this.map = params.map;
    this.states.SetValue(toolId, params.enabled);
  }
  SetView(view: string) {
    if (view !== 'spread-distribute') {
      this.Back('spread-distribute');
    }
    if (!!this.views) {

      this.views.SetView(view);

    }
  }
  public distributeStart: any;

  Next(view: string) {
    switch (view) {
      case 'spread-distribute':
        this.distributeViews.SetView('step2');
        this.distributeStart = this.currentVertex;
        this.currentVertex.ui.attr('data-dist-start', 'true');
        break;
      case 'split-distance':
        this.distSplitViews.SetView('step2');
        break;
      case 'split-number':
        this.numberSplitViews.SetView('step2');
        break;
      case 'split-at':
        this.numberSplitViews.SetView('step2');
        break;
    }
    this.ModeUpdate();
  }
  Back(view: string) {
    switch (view) {
      case 'spread-distribute':
        this.distributeStart?.ui?.attr('data-dist-start', null);
        if (this.distributeStart) {
          this.drawPane?.GetSelectedFeature()?.Select(this.distributeStart.id);
        }
        this.distributeStart = undefined;
        this.distributeViews?.SetView('step1');
        break;
      case 'split-distance':
        this.distSplitViews?.SetView('step1');
        break;
      case 'split-number':
        this.numberSplitViews?.SetView('step1');
        break;
      case 'split-at':
        this.numberSplitViews?.SetView('step1');
        break;
    }
    this.ModeUpdate();

  }
  ToggleDirection() {
    this.vertexDirection = (this.vertexDirection === 'to') ? 'from' : 'to';
  }
  GetFromTo(from: any, to: any) {
    if (this.vertexDirection === 'from') {
      return [to, from];
    }
    return [from, to];
  }
  Spread() {
    if (!this.spreadable) return;
    const from = this.distributeStart.coord as PixoSpatialCoord;
    const to = this.currentVertex.coord as PixoSpatialCoord;
    const bearing = this.drawPane.spatialContext.Bearing(from, to);
    const distance = this.drawPane.spatialContext.CoordDistance(from, to);
    const points = this.WalkTo(this.distributeStart, this.currentVertex);
    if (!points) return;
    if (!!points && points.length === 0) return;
    const distancePerSeg = distance / (points.length + 1);
    let start = this.distributeStart;
    for (const point of points) {
      const newCoord = this.drawPane.spatialContext.PointAtBearing(start.coord, distancePerSeg, bearing)
      point.coord.UpdateSpatial(newCoord.spatial.lng, newCoord.spatial.lat);
      point.updateUI();
      start = point;
    }
    this.Back('spread-distribute');
    this.ModeUpdate();
  }
  DistanceSplit() {
    if (!this.currentSegment) return;
    const [from, to] = this.GetFromTo(
      this.currentSegment.from.coord,
      this.currentSegment.to.coord
    )
    const bearing = this.drawPane.spatialContext.Bearing(from, to);
    const segDistance = this.drawPane.spatialContext.CoordDistance(from, to);
    let splitCount = Math.floor(segDistance / this.splitDistance);
    if (splitCount < 1) return;
    let start = this.GetFromTo(this.currentSegment.from, this.currentSegment.to).shift();
    while (splitCount > 0) {
      splitCount -= 1;
      const coord = this.drawPane.spatialContext.PointAtBearing(start.coord, this.splitDistance, bearing);
      start = this.drawPane.AddVertexFromCoord(coord);
      const nextSeg = this.GetFromTo(start.nextSeg(), start.prevSeg()).shift();
      if (!!nextSeg && splitCount > 0) this.drawPane.GetSelectedFeature().Select(nextSeg.id);
    }
    this.ModeUpdate();
  }
  SplitNumber(count?: number) {
    if (!this.currentSegment) return;
    const [from, to] = this.GetFromTo(
      this.currentSegment.from.coord,
      this.currentSegment.to.coord
    )
    count = !!count ? count : this.numSplits;
    if (count <= 1) return;
    const bearing = this.drawPane.spatialContext.Bearing(from, to);
    const segDistance = this.drawPane.spatialContext.CoordDistance(from, to);
    let splitCount = count - 1;
    if (splitCount < 1) return;
    const distancePerSeg = segDistance / count;
    let start = this.GetFromTo(this.currentSegment.from, this.currentSegment.to).shift();
    while (splitCount > 0) {
      splitCount -= 1;
      const coord = this.drawPane.spatialContext.PointAtBearing(start.coord, distancePerSeg, bearing);
      start = this.drawPane.AddVertexFromCoord(coord);
      const nextSeg = this.GetFromTo(start.nextSeg(), start.prevSeg()).shift();
      if (!!nextSeg && splitCount > 0) this.drawPane.GetSelectedFeature().Select(nextSeg.id);

    }
    this.ModeUpdate();

  }
  WalkTo(from, to) {
    const feature = this.drawPane.GetSelectedFeature();
    let pathInfo = feature.WalkForward(from, to);
    if (pathInfo.foundTarget === true) {
      return pathInfo.points;
    }
    pathInfo = feature.WalkBackward(from, to);
    if (pathInfo.foundTarget === true) {
      return pathInfo.points;
    }
    return undefined;
  }
  Refresh() {
    if (!this._ready) return;
    this.cdr.detectChanges();
  }
  Reset() {
    this.Back('spread-distribute');
    this.midPointViews?.SetView('step1');
    this.distSplitViews?.SetView('step1');
    this.numberSplitViews?.SetView('step1');
    if (this.drawPane?.GetSnaps().points.points.length > 0) {
      if (this.views.currentView.viewName === 'no-snap-layer') {
        this.views.SetView('noState');
      }
    }
    if (!!this.distributeStart) {
      this.distributeStart.ui.attr('data-dist-start', null);
    }
    this.states?.SetState('noState', true);
  }
}
